import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12e687bd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e687bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e687bd')) {
      api.createRecord('12e687bd', component.options)
    } else {
      api.reload('12e687bd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12e687bd&scoped=true", function () {
      api.rerender('12e687bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/index.vue"
export default component.exports